import ContentDocumentos from "ui/components/ContentDocumentos";
import usePastasUnidade from "core/features/unidades/usePastasUnidade";
import useDocumentosUnidade from "core/features/unidades/useDocumentosUnidade";
import useSavePastaDocumentoUnidade from "core/features/unidades/useSavePastaDocumentoUnidade";
import useSaveDocumentoUnidade from "core/features/unidades/useSaveDocumentoUnidade";

interface DocumentoProps {
  unidadeId: string;
}
export default function DocumentosUnidade({ unidadeId }: DocumentoProps) {
  return (
    <ContentDocumentos
      midComponent={false}
      title=""
      useDocumentos={useDocumentosUnidade}
      usePastas={usePastasUnidade}
      useSavePasta={useSavePastaDocumentoUnidade}
      useSaveDocumento={useSaveDocumentoUnidade}
      unidadeId={unidadeId}
      hideDestino
    />
  );
}
